import React, { useContext, useEffect, useMemo, useState } from 'react'
import useDataClient from './useDataClient'
import { UserNotification } from '../types'
import { AppContext, DashboardContext } from '../context'
import { sessionAdapter } from '../adapter'

interface UseNotificationsListReturn {
    notifications: UserNotification[],
    searchLastNotifications: (items: number) => void,
    setAllAsConfirmed: VoidFunction
}

export default function useNotificationsList(): UseNotificationsListReturn {
    const appContext = useContext(AppContext)
    const dashboardContext = useContext(DashboardContext)
    const notificationsClient = useDataClient<UserNotification[]>({ appContext })
    const notificationsAllClient = useDataClient<number>({ appContext })
    const notifications = useMemo<UserNotification[]>(() => {
        let items = notificationsClient.status.data || []
        items = items.map(i => {
            let menuTarget = dashboardContext?.appData['menu']?.find(m => i.body.includes(m.path || '__'))
            i.icon = menuTarget?.icon || 'bell'
            i.label = menuTarget?.label || 'Otras'
            return i
        })
        return items
    }, [notificationsClient.status.data, dashboardContext?.appData['menu']])
    const [lastItems, setLastItems] = useState(0)

    const setAllAsConfirmed = () => {
        notificationsAllClient.executeRequest(sessionAdapter.updateAllNotification())
    }
    function handleSearchItem(items: number) {
        notificationsClient.clean()
        setLastItems(items)
    }

    useEffect(() => {
        if (notificationsAllClient.status.data) {
            appContext?.setAppDialog({ type: 'success', message: `Notificaciones` })
            dashboardContext?.fullReload()
        }
    }, [notificationsAllClient.status.data])

    useEffect(() => {
        if (lastItems != 0 && !notificationsClient.status.data) {
            notificationsClient.executeRequest(sessionAdapter.getNotifications(lastItems))
        }
    }, [lastItems, notificationsClient.status.data])

    return { notifications, searchLastNotifications: handleSearchItem, setAllAsConfirmed }
}
